import { render, staticRenderFns } from "./Haemostaseologie.vue?vue&type=template&id=02f99e4e&scoped=true"
import script from "./Haemostaseologie.vue?vue&type=script&lang=js"
export * from "./Haemostaseologie.vue?vue&type=script&lang=js"
import style0 from "./Haemostaseologie.vue?vue&type=style&index=0&id=02f99e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f99e4e",
  null
  
)

/* custom blocks */
import block0 from "./Haemostaseologie.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports